module.exports = __webpack_public_path__ + "static/locations-map-65de5806bc7f5cecc72d51550e54f36e.png";